<template>
    <div>
        <div style="text-align: center">
            <h3>Tambah Paket</h3>
        </div>
        <br />
        <form v-on:submit.prevent="addNewPackage">
            <label for="">Nama Paket*</label>
            <input type="text" class="form-control" v-model="form.name" placeholder="Nama Paket" required />
            <br>
            <label for="">Max Device*</label>
            <input type="number" class="form-control" v-model="form.max_device" required />
            <br>
            <label for="">Max CS*</label>
            <input type="number" class="form-control" v-model="form.max_cs" required />
            <br>
            <label for="">Max Link Rotator*</label>
            <input type="number" class="form-control" v-model="form.max_link_rotator" required />
            <br>
            <label for="">Durasi (Hari)*</label>
            <input type="number" class="form-control" v-model="form.duration" required />
            <br>
            <label for="">Harga (Rupiah)*</label>
            <input type="number" class="form-control" v-model="form.price" required />
            <br>
            <div class="button-group d-flex pt-25">
                <button type="submit"
                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                    simpan
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    name: null,
                    max_device: null,
                    max_cs: null,
                    max_link_rotator: null,
                    duration: null,
                    price: null,
                },
            };
        },
        methods: {
            async addNewPackage() {
                try {
                    let req = {
                        name: this.form.name,
                        lisensi: 1,
                        message_quota: 0,
                        max_device: parseInt(this.form.max_device ?? 0),
                        max_cs: parseInt(this.form.max_cs ?? 0),
                        max_campaign: 0,
                        max_order_online: 0,
                        max_link_rotator: parseInt(this.form.max_link_rotator ?? 0),
                        max_chat_widget: 0,
                        is_addon: 0,
                        duration: parseInt(this.form.duration ?? 30),
                        price: parseInt(this.form.price ?? 0),
                        hide: 0,
                        webhook_media_quota: 0,
                        whitelist: []
                    }

                    let response = await this.$store.dispatch('admin_package_create', req)
                    this.$toast.success(response.data.message);
                    this.$root.$emit("toggle_modal", "new_paket")
                    this.$root.$emit("refresh_table", true)
                    
                    // Reset form
                    this.form = {
                        name: null,
                        max_device: null,
                        max_cs: null,
                        max_link_rotator: null,
                        duration: null,
                        price: null,
                    }
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            }
        },
    };
</script>

<style scoped>

</style>
